import { prop } from '@lib/style/theme';
import { unitStrict } from '@lib/style/unit';
import { FlexDirection, getJustifyAlign, JustifyAlignValue } from '@lib/style/utils';
import Grid, { GridProps } from '@material-ui/core/Grid';
import { createMemo } from '@packages/react';
import React from 'react';
import styled, { css } from 'styled-components';

export interface ContainerProps extends Omit<GridProps, 'justify'> {
    maxWidth?: string | number;
    responsive?: boolean;
    fluid?: boolean;
    align?: JustifyAlignValue;
    justify?: JustifyAlignValue;
    layout?: FlexDirection;
}

/**
 * @author: Dumitrana Alinus <alin.designstudio@gmail.com>
 * @class: Container
 * @date:  18.09.2018
 * @time:  00:53
 * @revisions:
 * - Dumitrana Alinus [01.11.2019 00:51]: TS support, performance, clean code
 */
const ContainerComponent = createMemo<ContainerProps>(
    (props: ContainerProps) => {
        const { fluid, align, layout, maxWidth, responsive, ...rest } = props;

        const align$ = getJustifyAlign(align || rest.alignContent || rest.alignItems) as any;

        if (rest.justify) {
            rest.justify = getJustifyAlign(rest.justify);
        }

        rest.direction = layout;
        rest.alignContent = align$;
        rest.alignItems = align$;
        rest.container = true;
        rest.spacing = rest.spacing || 2;

        return <Grid {...(rest as any)} />;
    },
    {
        displayName: 'Container',
        defaultProps: {
            direction: 'row',
            align: 'start',
        },
    },
);

export const Container = styled(ContainerComponent)<ContainerProps>`
    && {
        position: relative;
        margin: 0 auto;
        width: 100%;
        @media screen and (max-width: 426px) {
            overflow: scroll;
        }
        ${(props) =>
            !props.fluid
                ? css`
                      & {
                          max-width: ${prop('maxWidth', 1280, unitStrict)};
                          @media screen and (min-width: 961px) and (max-width: 1599px) {
                              max-width: calc(100% - 40px);
                          }
                      }
                  `
                : ''}

        ${({ responsive }): any =>
            responsive
                ? css`
                      @media screen and (max-width: 960px) {
                          max-width: 100%;
                      }
                  `
                : ''}
    }
`;
